// 1) Define the shape of all your needed vars
type EnvVars = {
  REACT_APP_USDC_ADDRESS: string;
  REACT_APP_ENV: string;
  REACT_APP_PRIVY_APP_ID: string;
};

// 2) Build‐time defaults (from process.env) for local/dev
const devEnv: EnvVars = {
  REACT_APP_USDC_ADDRESS: process.env.REACT_APP_USDC_ADDRESS!,
  REACT_APP_ENV: process.env.REACT_APP_ENV!,
  REACT_APP_PRIVY_APP_ID: process.env.REACT_APP_PRIVY_APP_ID!
};

// 3) Declare the runtime global
declare global {
  interface Window {
    __ENV__?: Partial<EnvVars>;
  }
}

// 4) Pick from window.__ENV__ in production, else from devEnv
export const USDC_ADDRESS =
  process.env.NODE_ENV === "development" ? devEnv.REACT_APP_USDC_ADDRESS : window.__ENV__?.REACT_APP_USDC_ADDRESS ?? "";

export const REACT_APP_ENV =
  process.env.NODE_ENV === "development" ? devEnv.REACT_APP_ENV : window.__ENV__?.REACT_APP_ENV ?? "";

export const REACT_APP_PRIVY_APP_ID =
  process.env.NODE_ENV === "development" ? devEnv.REACT_APP_PRIVY_APP_ID : window.__ENV__?.REACT_APP_PRIVY_APP_ID ?? "";
